export default __webpack_public_path__ + "static/media/hdb-flat-completed.12835bdf.svg";